import { FormProvider } from 'react-hook-form';
import { Divider } from '../../..';
import AuthLayout from '../Layout';
import LoginForm from './Form/index';
import useLogin from './useLogin';

const Login: React.FC = () => {
  const { methods, loading, error, resetPasswordLink, handleLogin } =
    useLogin();

  return (
    <FormProvider {...methods}>
      <AuthLayout position="left">
        <div className="w-full">
          <Divider />
          <LoginForm
            onSubmit={handleLogin}
            loading={loading}
            resetPasswordLink={resetPasswordLink}
            error={error}
          />
        </div>
      </AuthLayout>
    </FormProvider>
  );
};

export default Login;
